export const offerNavbar = () => {
  const navbar = document.getElementById('navbar-offer');
  if (!navbar) {
    return;
  }

  const breakValue = window.BREAKPOINTS.isMobile || window.BREAKPOINTS.isTablet ? 44 : 100;
  window.addEventListener('scroll', () => {
    if (window.scrollY > breakValue) {
      navbar.classList.add('active');
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('active');
      navbar.classList.remove('scrolled');
    }
  });
};
